import React, { FC, useCallback, useEffect, useState } from 'react'
import { Form, Formik, FormikProps } from 'formik'
import {
    InsuranceExpenseModel,
    initialInsuranceExpense,
    validationInsuranceExpense,
    tabOptions,

} from './InsuranceExpenseModel'
import {
    createInsuranceExpense,
    deleteInsuranceExpense,
    loadInsuranceExpenses,
    updateInsuranceExpense,
} from './Api'
import { ConfirmModal } from '../../../../shared/components/ConfirmModal'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import FormTabHeader from '../../../../shared/components/FormTabHeader'
import TextInput from '../../../../shared/components/TextInput'
import SelectInput from '../../../../shared/components/SelectInput'
import TextAreaInput from '../../../../shared/components/TextAreaInput' 
import { showErrorToast, showSuccessToast } from '../../../../shared/components/ToastUtils' 
import { branches } from '../../../../shared/models/SharedApiLookups'

export const InsuranceExpensePage: FC = () => {
    const [tab, setTab] = useState<string | 'bilgi'>('bilgi')
    const [locations, setLocations] = useState<InsuranceExpenseModel[]>([])
    const [loading, setLoading] = useState(false)
    const [selectedId, setSelectedId] = useState<string | null>(null)
    const [showModal, setShowModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const [branchOptions, setBranchOptions] = useState<{value: string; label: string}[]>([])

    const fetchLocations = useCallback(async (page: number = 0) => {
        try {
            const res = await loadInsuranceExpenses(page)
            const data = res.data.payload || res.data
            setLocations(data.content || data || [])
            setTotalPages(data.totalPages || 1)
        } catch (err) {
            const error = err as any
            if (error.response?.status === 401) {
                window.location.href = '/login'
            }
            console.error(error)
            showErrorToast('Lokasyonlar yüklenirken bir hata oluştu')
        }
    }, [])

    useEffect(() => {
        fetchLocations(currentPage)
    }, [fetchLocations, currentPage])

    const handleSave = async (values: InsuranceExpenseModel, resetForm: () => void) => {
        setLoading(true)
        try {
            if (selectedId) {
                await updateInsuranceExpense({ ...values, id: selectedId })
                showSuccessToast('Lokasyon başarıyla güncellendi')
            } else {
                await createInsuranceExpense(values)
                showSuccessToast('Lokasyon başarıyla oluşturuldu')
            }
            setCurrentPage(0)
            await fetchLocations(0)
            resetForm()
            setSelectedId(null)
            setTab('list')
        } catch (err) {
            showErrorToast('Bir hata oluştu')
        } finally {
            setLoading(false)
        }
    }

    const handleEdit = (loc: InsuranceExpenseModel, formik: FormikProps<InsuranceExpenseModel>) => {
        formik.setValues(loc)
        setSelectedId(loc.id)
        setTab('form')
    }

    const handleDelete = async () => {
        if (selectedId) {
            try {
                await deleteInsuranceExpense(selectedId)
                showSuccessToast('Lokasyon başarıyla silindi')
                await fetchLocations(currentPage)
            } catch (err) {
                console.error(err)
                showErrorToast('Lokasyon silinirken bir hata oluştu')
            } finally {
                setShowModal(false)
                setSelectedId(null)
            }
        }
    }

    const handlePageChange = (newPage: number) => {
        if (newPage >= 0 && newPage < totalPages) {
            setCurrentPage(newPage)
        }
    }
     useEffect(() => {
       Promise.all([branches()]).then(
         ([brn]) => {
           setBranchOptions(brn)
         }
       )
     }, [])
    return (
        <>
            <Formik
                initialValues={initialInsuranceExpense}
                validationSchema={validationInsuranceExpense}
                enableReinitialize
                onSubmit={(values, { resetForm }) => handleSave(values, resetForm)}
            >
                {(formik) => {
                    const handleReset = () => {
                        formik.resetForm()
                        setSelectedId(null)
                    }

                    return (
                        <>
                            <FormTabHeader
                                formId='locationForm'
                                formikSubmit={formik.handleSubmit}
                                formikReset={handleReset}
                                loading={loading}
                                tab={tab}
                                setTab={setTab}
                                setSelectedId={setSelectedId}
                                tabs={tabOptions}
                                onExportExcel={() => console.log('Excel export')}
                            />

                            {tab === 'bilgi' && (
                                <div className='card mb-5'>
                                    <Form id='insuranceExpenseForm' className='form card-body'>
                                        <div className='row mb-6'>
                                            <TextInput name='date'
                                                label='Tarih'
                                                type='date'
                                                wrapperClassName='col-md-6' />
                                            <SelectInput
                                                name="branchId"
                                                label="Şube Adı"
                                                options={branchOptions}
                                                wrapperClassName="col-md-6"
                                            /> 
                                            <SelectInput
                                                name='insuranceType'
                                                label='Sigorta Türü'
                                                options={[{ value: 'casko', label: 'casko' }, { value: 'Trafik', label: 'Trafik' }]}
                                                wrapperClassName='col-md-6'
                                            />
                                            <TextInput name='policyNumber'
                                                label='Poliçe No'
                                                wrapperClassName='col-md-6' />
                                            <TextInput name='insuranceStartDate'
                                                label='Sigorta Baş. Tarih'
                                                type='date'
                                                wrapperClassName='col-md-6' />
                                            <TextInput name='insuranceEndDate'
                                                label='Sigorta Bit. Tarih'
                                                type='date' wrapperClassName='col-md-6' />

                                            <TextInput name='transactor'
                                                label='İşlem Yapan'
                                                wrapperClassName='col-md-6' />
                                            <TextInput name='vehicleValue'
                                                label='Araç Değeri' type='number'
                                                wrapperClassName='col-md-6' />
                                            <TextInput name='iMMValue'
                                                label='IMM Değeri'
                                                type='number'
                                                wrapperClassName='col-md-6' />
                                            <TextInput name='accessoryValue'
                                                label='Aksesuar Değeri'
                                                type='number'
                                                wrapperClassName='col-md-6' />
                                            <TextInput name='amount'
                                                label='Tutar' type='number'
                                                wrapperClassName='col-md-6' />
                                            <TextInput name='remainder'
                                                label='Kalan'
                                                type='number'
                                                wrapperClassName='col-md-6' />
                                        </div>

                                        <div className='row mb-2'>

                                            <TextInput name='insuranceCompany'
                                                label='Sigorta Firması'
                                                wrapperClassName='col-md-6' />

                                            <TextAreaInput name='description'
                                                label='Açıklama'
                                                wrapperClassName='col-md-12' />
                                        </div>
                                    </Form>
                                </div>
                            )}

                            {tab === 'odeme' && (
                                <div className='card mb-5'>
                                    <Form id='insuranceExpenseForm' className='form card-body'>
                                        <div className='row mb-6'>
                                            <div className='col-md-6'>
                                                <div className='row'>
                                                    <TextInput name='paymentDate'
                                                        label='Ödeme Tarihi'
                                                        type='date'
                                                        wrapperClassName='col-md-6' />
                                                    <div className='col-md-6 d-flex align-items-end'>
                                                        <div className='row w-100'>
                                                            <TextInput name='payment'
                                                                label='Ödeme'
                                                                type='number'
                                                                wrapperClassName='col-4' />


                                                        </div>
                                                    </div>
                                                    <SelectInput
                                                        name='paymentType'
                                                        label='Ödeme Türü'
                                                        options={[{ value: 'CASH', label: 'Nakit' }, { value: 'POS', label: 'POS' }, { value: 'IBAN', label: 'Havale/EFT (IBAN)' }]}
                                                        wrapperClassName='col-md-12'
                                                    />
                                                    <SelectInput
                                                        name='cashRegisterCode'
                                                        label='Kasa Kodu'
                                                        options={[{ value: 'MERKEZ', label: 'MERKEZ' }, { value: 'SUBE1', label: 'ŞUBE 1' }, { value: 'SUBE2', label: 'ŞUBE 2' }]}
                                                        wrapperClassName='col-md-12'
                                                    />
                                                    <SelectInput
                                                        name='iban'
                                                        label='IBAN (Hesap No)'
                                                        options={[{ value: 'TR00....TL', label: 'ŞAHSİ HESAP - TL' }, { value: 'TR00....USD', label: 'FİRMA HESAP - USD' }, { value: 'TR00....EUR', label: 'FİRMA HESAP - EUR' }]}
                                                        wrapperClassName='col-md-12'
                                                    />
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <TextAreaInput name='description'
                                                    label='Açıklama'
                                                    rows={6} wrapperClassName='col-12' />
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            )}

                            {tab === 'arac' && (
                                <div className='card mb-5'>
                                    <Form id='insuranceExpenseForm' className='form card-body'>


                                    </Form>
                                </div>
                            )}

                            {tab === 'zeyil' && (
                                <div className='card mb-5'>
                                    <Form id='insuranceExpenseForm' className='form card-body'>
                                        <div className='row mb-6'>
                                            <div className='col-md-6'>
                                                <TextInput name='endorsmentDate'
                                                    label='Zeyil Tarihi'
                                                    type='date'
                                                    wrapperClassName='col-12' />
                                                <TextInput name='endorsmentIssueDate'
                                                    label='Zeyil Tanzimi'
                                                    type='date'
                                                    wrapperClassName='col-12' />
                                                <TextInput name='endorsmentNo'
                                                    label='Zeyil No'
                                                    wrapperClassName='col-12' />
                                                <TextInput name='endorsmentDescription'
                                                    label='Zeyil Açıklama'
                                                    wrapperClassName='col-12' />
                                                <TextInput name='endorsmentype'
                                                    label='Zeyil Tipi'
                                                    wrapperClassName='col-12' />
                                            </div>
                                            <div className='col-md-6'>
                                                <TextInput name='endorsmentReason'
                                                    label='Zeyil Nedeni'
                                                    wrapperClassName='col-12' />
                                                <TextInput name='endorsmentValue'
                                                    label='Zeyil Değeri'
                                                    wrapperClassName='col-12' />
                                                <TextInput name='endorsmentGrossPremium
                                                ' label='Zeyil Brüt Prim'
                                                    type='number'
                                                    wrapperClassName='col-12' />
                                                <TextInput name='endorsmentNetPremium'
                                                    label='Zeyil Net Prim'
                                                    type='number'
                                                    wrapperClassName='col-12' />
                                                <TextInput name='endorsmentTax'
                                                    label='Zeyil Vergi'
                                                    wrapperClassName='col-12' />
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            )}

                            {tab === 'list' && (
                                <div className='d-flex justify-content-between align-items-center mt-5'>
                                    <button className='btn btn-sm btn-light'
                                        disabled={currentPage === 0}
                                        onClick={() => handlePageChange(currentPage - 1)}>Önceki</button>
                                    <span>Sayfa {currentPage + 1} / {totalPages}</span>
                                    <button className='btn btn-sm btn-light'
                                        disabled={currentPage >= totalPages - 1}
                                        onClick={() => handlePageChange(currentPage + 1)}>Sonraki</button>
                                </div>
                            )}

                        </>
                    )
                }}
            </Formik >

            <ConfirmModal
                show={showModal}
                header='Silme Onayı'
                text='Bu lokasyonu silmek istediğinize emin misiniz?'
                handleClose={() => {
                    setShowModal(false)
                    setSelectedId(null)
                }}
                applyOnClick={handleDelete}
            />

            <ToastContainer
                position='top-right'
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}
